export const GRID_MAX_WIDTH = 1600;
